/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_UpperInputs */

const vi_shop_home_pos_upper = /** @type {(inputs: Shop_Home_Pos_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hơi lệch lên (ảnh dọc)`)
};

/**

* @param {Shop_Home_Pos_UpperInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_upper = /** @type {((inputs?: Shop_Home_Pos_UpperInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_UpperInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_upper(inputs)
});